import type { LocationType } from '@sdk/locations/types/LocationType';

import type { LocationsFormType } from '../types/LocationsForm';

type LocationPayload = {
  id?: number;
  name: string;
  type: 'location';
  timezone: string;
};

export const getLocationsPayloads = (
  locations: LocationType[],
  updatedLocations: LocationsFormType[]
): LocationPayload[] => {
  return updatedLocations.map((updatedLocation) => {
    const location = locations.find(({ id }) => id === updatedLocation.id.value);

    return {
      ...location,
      address: updatedLocation.address.value,
      coordinates: updatedLocation.coordinates.value ? updatedLocation.coordinates.value : null,
      mapZoom: updatedLocation.coordinates.value ? '10' : '1',
      mapCenter: updatedLocation.coordinates.value ? updatedLocation.coordinates.value : '',
    };
  });
};
